import { apiClient } from "../../../base/ApiClient";

export const getAllAssessmentForms = async (status = "active", carePlanId = null) => {
  const params = { status };
  if (carePlanId) {
    params.care_plan_id = carePlanId;
  }
  const res = await apiClient.get("/assessments/all/", { params });
  return res.data;
};

export const assignAssessmentFormToClient = async (payload) => {
  const res = await apiClient.post("/assessments/assigned-forms/", payload);
  return res.data;
};

export const getAssignedFormsByClient = async (clientID, carePlanId = null) => {
  const params = { client: clientID };
  if (carePlanId) {
    params.care_plan_id = carePlanId;
  }
  const res = await apiClient.get(`/assessments/assigned-forms/`, { params });
  return res.data;
};

export const getAssignedClientAssessments = async (clientID, carePlanId = null) => {
  const params = {};
  if (carePlanId) {
    params.care_plan_id = carePlanId;
  }
  const res = await apiClient.get(`/assessments/${clientID}/assigned-assessments/`, { params });
  return res.data;
};

export const getAssignedFormDetails = async (clientID, formID, carePlanId = null) => {
  const params = {};
  if (carePlanId) {
    params.care_plan_id = carePlanId;
  }
  const res = await apiClient.get(`/assessments/${clientID}/assigned-assessments/${formID}/`, { params });
  return res.data;
};

export const getAllAssessmentSubmissions = async () => {
  const res = await apiClient.get("/assessments/assessment-submissions/");
  return res.data;
};

export const getAssessmentSubmissionDetail = async (id) => {
  const res = await apiClient.get(`/assessments/assessment-submissions/${id}/`);
  return res.data;
};

export const createAssessmentSubmission = async (payload) => {
  const res = await apiClient.post("/assessments/assessment-submissions/", payload);
  return res.data;
};

export const updateAssessmentSubmission = async (payload) => {
  const res = await apiClient.patch(`/assessments/assessment-submissions/${payload.id}/`, payload);
  return res.data;
};

export const deleteAssessmentSubmission = async (id) => {
  const res = await apiClient.delete(`/assessments/assessment-submissions/${id}/`);
  return res.data;
};

export const getAssessmentPrintData = async (submissionId) => {
  const res = await apiClient.get(`/assessments/${submissionId}/print-data/`);
  return res.data;
};